<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-dialog
      style="opacity: 1;"
      :value="showSignUpForm"
      width="50%"
      @click:outside="toggleSignUpForm()"
    >
      <v-card class="popup" style="overflow-y: auto; ">
        <v-toolbar dark class="v-toolbar">
          <v-toolbar-title>
            Project Updates Sign Up
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="toggleSignUpForm()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- Begin Mailchimp Signup Form -->
        <link
          href="//cdn-images.mailchimp.com/embedcode/classic-071822.css"
          rel="stylesheet"
          type="text/css"
        />

        <div id="mc_embed_signup">
          <form
            action="https://itsmarta.us18.list-manage.com/subscribe/post?u=bc184f8e095ffaa20cf0a3aa7&amp;id=2be69ab29e&amp;f_id=007e3be1f0"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            class="validate"
            target="_self"
          >
            <div id="mc_embed_signup_scroll">
              <h2>Subscribe</h2>
              <div class="indicates-required">
                <span class="asterisk">*</span> indicates required
              </div>
              <div class="mc-field-group">
                <label for="mce-EMAIL"
                  >Email Address <span class="asterisk">*</span>
                </label>
                <input
                  type="email"
                  value=""
                  name="EMAIL"
                  class="required email"
                  id="mce-EMAIL"
                  required
                />
                <span id="mce-EMAIL-HELPERTEXT" class="helper_text"></span>
              </div>
              <div class="mc-field-group">
                <label for="mce-FNAME">First Name </label>
                <input
                  type="text"
                  value=""
                  name="FNAME"
                  class=""
                  id="mce-FNAME"
                />
                <span id="mce-FNAME-HELPERTEXT" class="helper_text"></span>
              </div>
              <div class="mc-field-group">
                <label for="mce-LNAME">Last Name </label>
                <input
                  type="text"
                  value=""
                  name="LNAME"
                  class=""
                  id="mce-LNAME"
                />
                <span id="mce-LNAME-HELPERTEXT" class="helper_text"></span>
              </div>
              <div class="mc-field-group">
                <label for="mce-ZIP">Zip Code </label>
                <input type="text" value="" name="ZIP" class="" id="mce-ZIP" />
                <span id="mce-ZIP-HELPERTEXT" class="helper_text"></span>
              </div>
              <div hidden="true">
                <input type="hidden" name="tags" value="787049" />
              </div>
              <div id="mce-responses" class="clear">
                <div
                  class="response"
                  id="mce-error-response"
                  style="display:none"
                ></div>
                <div
                  class="response"
                  id="mce-success-response"
                  style="display:none"
                ></div>
              </div>
              <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
              <div
                style="position: absolute; left: -5000px;"
                aria-hidden="true"
              >
                <input
                  type="text"
                  name="b_bc184f8e095ffaa20cf0a3aa7_2be69ab29e"
                  tabindex="-1"
                  value=""
                />
              </div>
              <div class="clear">
                <input
                  type="submit"
                  value="Subscribe"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                  class="button"
                  style="background-color: #008CCC;"
                />
              </div>
            </div>
          </form>
        </div>
        <!--End mc_embed_signup-->
      </v-card>
    </v-dialog>
    <v-row class="fill-height" align="center" justify="center">
      <div
        style="position: absolute; 
        bottom: 0px; 
        right:0px; 
        background-color: white; 
        padding: 10px; 
        
        border-top-left-radius: 5px;
        text-align: bottom;"
      >
        <v-img
          src="https://streetcar-east.s3.us-east-2.amazonaws.com/MARTA+2040_300px.png"
          :width="200"
        ></v-img>
      </div>
      <v-col
        align="center"
        style="padding-bottom: 0%; max-height: 85vh; overflow-y: auto;"
      >
        <v-card class="stayengaged-card" align="left">
          <div class="slide-content">
            <div style="padding-bottom: 3%;">
              <h1 id="header">Remember to Connect with Us</h1>
              <p>
                We hope the information provided here answered many of your
                questions and you learned more about the Streetcar East
                Extension project. For more project information, contact Project
                Manager Bryan Hobbs.
              </p>
              <p>
                Email Bryan at
                <a href="mailto:jhobbs@itsmarta.com">jhobbs@itsmarta.com</a>
              </p>
              <p>
                Remember to follow MARTA on social media for the latest updates.
                We hope to connect with you again in the future!
              </p>
              <v-row
                justify="center"
                style="padding-top: 3%;padding-bottom: 5%;"
              >
                <v-btn
                  color="primary"
                  dark
                  class="buttons"
                  @click="toggleSignUpForm"
                  >Sign Up for Project Updates</v-btn
                >
              </v-row>
              <p>
                To download all the documents and displays available here as a
                PDF, click the “Document” icon.
              </p>
            </div>
            <v-row align="center">
              <v-col cols="12" align="center">
                <v-card flat tile color="white">
                  <v-row>
                    <v-col v-for="link in links" :key="link.name">
                      <v-btn icon x-large target="_blank" :href="link.link">
                        <v-icon color="black">{{ link.icon }}</v-icon>
                      </v-btn>
                      <p>{{ link.name }}</p>
                    </v-col>
                    <v-col>
                      <v-btn icon x-large>
                        <v-icon color="black" @click="toggleDocuments"
                          >far fa-file</v-icon
                        >
                      </v-btn>
                      <p>Documents</p>
                    </v-col>
                  </v-row>
                </v-card>
                <v-row><p></p></v-row>
                <v-row align-end style="padding-top: 12px; padding-left: 1%;"
                  ><p id="bottomtext">
                    Text modified on 2022-12-08.
                  </p></v-row
                >
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="toggled" :width="modalWidth">
      <v-sheet width="100%">
        <v-list>
          <v-list-item-group color="blue">
            <v-subheader style="font-size: 2rem;">Documents</v-subheader>
            <v-list-item v-for="pdf in pdfs" :key="pdf.name">
              <a
                :href="getFile(pdf.link)"
                target="_blank"
                style="width: 100%; text-decoration: none !important;"
              >
                <v-list-item-content>
                  <v-list-item-title
                    ><span id="doc-name">{{
                      pdf.name
                    }}</span></v-list-item-title
                  >
                </v-list-item-content>
              </a>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-sheet>
    </v-dialog>
  </v-sheet>
</template>

<script>
export default {
  name: "StayEngaged",
  data() {
    return {
      showSignUpForm: false,
      links: [
        {
          name: "Website",
          link: "https://www.itsmarta.com/",
          icon: "fas fa-globe"
        },
        {
          name: "Facebook",
          link: "https://www.facebook.com/MARTAtransit/",
          icon: "fab fa-facebook"
        },
        {
          name: "Twitter",
          link: "https://twitter.com/MARTASERVICE/",
          icon: "fab fa-twitter"
        },
        {
          name: "Instagram",
          link: "https://www.instagram.com/marta_explorers/",
          icon: "fab fa-instagram"
        }
        // {
        //   name: "Q&A Responses",
        //   link: [
        //     "https://streetcar-east.s3.us-east-2.amazonaws.com/SCE_052721_Q%26A_Batch1.pdf",
        //     "https://streetcar-east.s3.us-east-2.amazonaws.com/SCE_052721_QA_Batch2.pdf",
        //   ],
        //   icon: "fa-question"
        // }
      ],
      pdfs: [
        {
          name: "Virtual Public Meeting Presentation",
          link:
            "https://streetcar-east.s3.us-east-2.amazonaws.com/SCE+September+2022+Virtual+Public+Meeting+Presentation.pdf",
          icon: "fa-question"
        },
        {
          name: "Streetcar East Extension Tour",
          link:
            "https://vimeo.com/740426533/6aef507132?embedded=true&source=video_title&owner=29239061",
          icon: "fa-question"
        },
        {
          name: "Fact Sheet",
          link:
            "https://streetcar-east.s3.us-east-2.amazonaws.com/projectInfo.jpg",
          icon: "fa-question"
        },
        {
          name: "FAQ",
          link:
            "https://streetcar-east.s3.us-east-2.amazonaws.com/FAQ.pdf",
          icon: "fa-question"
        }
      ],
      documentsUrl:
        "https://streetcar-east.s3.us-east-2.amazonaws.com/Streetcar+East+Extension+Project.pdf",
      toggled: false
    };
  },
  computed: {
    modalWidth() {
      if (this.$vuetify.breakpoint.xs) {
        return "90%";
      }
      return "40%";
    }
  },
  methods: {
    goToLink(link) {
      window.open(link, "_blank");
    },
    toggleDocuments() {
      this.toggled = !this.toggled;
    },
    getFile(link) {
      return link;
    },
    toggleSignUpForm() {
      this.showSignUpForm = !this.showSignUpForm;
    }
  }
};
</script>
